import { notifications } from '@mantine/notifications';
import { IconExclamationCircle } from '@tabler/icons-react';
import { useMutation } from '@tanstack/react-query';
import { Endpoints } from '@xver/apis';
import type { ResetPasswordResponse } from '@xver/apis/v1/registry/model';
import { useTranslation } from 'react-i18next';

export function useResetRegistryPasswordMutate(options?: {
    onSuccess?: (data: ResetPasswordResponse) => void;
}) {
    const { t } = useTranslation('artifactRegistry');

    return useMutation<ResetPasswordResponse, { message?: string; status?: number } | null>({
        mutationFn: () => Endpoints.v1.Registry.resetPassword(),
        onSuccess: (data) => {
            options?.onSuccess?.(data);
        },
        onError: (err) => {
            notifications.show({
                title: t('auth.toast.resetErrorTitle', 'Failed to reset password'),
                message:
                    err?.message ??
                    t(
                        'auth.toast.resetErrorMessage',
                        'Please try again later. If the problem persists, activate the registry by deploying a container first.'
                    ),
                icon: <IconExclamationCircle size={18} color="#eb5757" />,
            });
        },
    });
}
